function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(45)",
    ry: 0,
    y: -1,
    x: 4.3137083,
    height: 2,
    width: 14,
    style: {
      opacity: 1,
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 3.2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-45)",
    ry: 0,
    y: 10.313708,
    x: -7,
    height: 2,
    width: 14,
    style: {
      opacity: 1,
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 3.2,
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.84d1dc507c94240032bad6b6c39cf7ea.svg";
export { ForwardRef as ReactComponent };